import { render, staticRenderFns } from "./AmazonCatalogueComponent.vue?vue&type=template&id=4a99d734&scoped=true&"
import script from "./AmazonCatalogueComponent.vue?vue&type=script&lang=js&"
export * from "./AmazonCatalogueComponent.vue?vue&type=script&lang=js&"
import style0 from "./AmazonCatalogueComponent.vue?vue&type=style&index=0&id=4a99d734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99d734",
  null
  
)

export default component.exports